import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_sales_reports,
  get_sales_tax_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const SalesVatReport = () => {
  let location = useLocation();
  let componentRef = useRef();  

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Sales Vat Report",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: new Date(),
          end: new Date(),
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_sales_tax_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <div className="text-right pb-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500 w-36"
                  type="button"
                  size="large"
                >
                  Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef}
              pageStyle={`
              @page {
                size: landscape;
                margin: 20mm;
              }
                table {
                border-collapse: collapse;
                width: 100%;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 6px;
              }
              th {
                background-color: #f4f4f4;
              }
            `}
            />
          </div>
        </div>
        <table className="w-full bg-white" ref={(el) => (componentRef = el)}>
          <thead className="text-gray-500">
            <tr>
              <td className="border p-4">Invoice</td>
              <td className="border p-4">Customer</td>
              <td className="border p-4">Branch</td>
              <td className="border p-4">Date</td>
              <td className="border p-4">Subtotal</td>
              <td className="border p-4">Taxable&nbsp;Amount</td>
              <td className="border p-4">Tax&nbsp;[VAT]</td>
              <td className="border p-4">Total</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr>
                  <td className="border p-4">#INV-{value?.number}</td>
                  <td className="border p-4">
                    <div>{value?.customer?.name}</div>
                    <div className="text-gray-500 text-xs">
                      {value?.customer?.tax
                        ? "VATIN : " + value?.customer?.tax
                        : ""}
                    </div>
                  </td>
                  <td className="border p-4">{value?.branch?.name}</td>
                  <td className="border p-4">
                    {value?.date
                      ? moment?.(value?.date)?.format?.("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td className="border p-4">
                    {value?.subtotal?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">{value?.taxable_amount}</td>
                  <td className="border p-4">
                    {value?.taxamount?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">{value?.total?.toFixed?.(3)}</td>
                </tr>
              );
            })}
          </tbody>
          <tbody>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4 text-medium">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.subtotal),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4 text-medium">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.taxable_amount),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4 text-medium">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.taxamount),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4 text-medium">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                )
                ?.toFixed(3)}
            </td>
          </tbody>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default SalesVatReport;
